var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"search_content_textBox"},[_c('div',{staticClass:"search_content_textBox_top"},[_vm._v("검색결과")])]),_c('div',{staticClass:"empty_list"},[_c('div',{staticClass:"empty_img"}),_c('div',{staticClass:"empty_text"},[_vm._v("검색어를 입력해주세요.")])])])
}]

export { render, staticRenderFns }